import React from 'react'
import { DragDropContext } from 'react-beautiful-dnd'
import cloneDeep from 'lodash/cloneDeep'
import Column from './Column'

import '../stylesheets/components/Interface.scss'

const shuffle = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[a[i], a[j]] = [a[j], a[i]]
    }
    return a
}

class Interface extends React.Component {
    state = {}
    static getDerivedStateFromProps(props, state) {
        if (state.round !== parseInt(props.match.params.round)) {
            const cards = shuffle(
                props.cards
                    .filter((card) => card.round === parseInt(props.match.params.round))
                    .map((card, key) => ({
                        id: card.id,
                        visible: !key,
                        title: card[props.validation.language],
                    })),
            )
            const columns = [
                { description: props.validation.stack, cards: cards.map((card) => card.id) },
                ...props.columns.map((column) => ({
                    id: column.column,
                    description: column.description,
                    extra: column.extra,
                    cards: [],
                })),
            ]
            return { cards, columns, round: parseInt(props.match.params.round) }
        }
        return null
    }
    pickCard = () => {
        const next =
            (this.state.columns
                .map((column) => (!!column.id ? column.cards : []))
                .flat()
                .sort((a, b) => {
                    return +a - +b
                })
                .reverse()[0] || 0) + 1
        if (this.state.cards.find((card) => card.id === next)) {
            const clone = cloneDeep(this.state.cards)
            clone.find((card) => card.id === next).visible = true
            this.setState({ cards: clone })
        }
        this.handleStatusUpdate()
    }
    onDragEnd = (result) => {
        if (!result.destination) return
        const id = result.draggableId.replace(/\D+/g, '') * 1
        const sourceColumnIndex = result.source.droppableId.replace(/\D+/g, '') * 1
        const sourceCardIndex = result.source.index
        const destinationColumnIndex = result.destination.droppableId.replace(/\D+/g, '') * 1
        const destinationCardIndex = result.destination.index
        const clone = cloneDeep(this.state.columns)
        clone[sourceColumnIndex].cards.splice(sourceCardIndex, 1)
        clone[destinationColumnIndex].cards.splice(destinationCardIndex, 0, id)
        this.setState({ columns: clone }, () => {
            this.pickCard()
        })
    }
    componentDidMount = () => {
        this.handleStatusUpdate()
    }
    handleStatusUpdate = () => {
        this.props.update(
            this.state.columns[0].cards.length === 0,
            this.state.columns
                .filter((column, key) => !!key)
                .map((column) => ({ id: column.id, cards: column.cards })),
        )
    }
    render() {
        return (
            <div className="Interface">
                <DragDropContext onDragEnd={this.onDragEnd}>
                    {this.state.columns.map((column, key) => {
                        column = cloneDeep(column)
                        column.cards = column.cards.map((id) =>
                            this.state.cards.find((card) => card.id === id),
                        )
                        return (
                            <Column
                                key={key}
                                column={column}
                                columns={this.props.columns}
                                caption={this.props.set.caption}
                            />
                        )
                    })}
                </DragDropContext>
                <div
                    className="Interface_headers"
                    style={{ backgroundColor: this.props.validation.color }}>
                    {this.state.columns.map((item, key) => (
                        <div
                            key={key}
                            className="Interface_header"
                            style={{ width: `${100 / (this.props.columns.length + 1)}%` }}>
                            <div className="Interface_title">
                                {item.description}
                                <br />
                                <span>{item.extra}</span>
                                {!key && (
                                    <em>
                                        {item.cards.length}/
                                        {this.state.columns
                                            .map((column) => column.cards.length)
                                            .reduce((sum, x) => sum + x)}
                                    </em>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export default Interface
